import React from "react"
import CircularProgress from '@mui/material/CircularProgress'

export default function DistVafCircularProgress() {
       return (
        <CircularProgress size={120}
            sx={{
                color: '#b2102f',
                position: 'fixed',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
                boxShadow: "inset 0 0 0px 1px gray",
                backgroundColor: "transparent",
                borderRadius: "100%",
                thickness: 4,
                zIndex: 9999,
            }} />
    );
};                    